export const CLEAR_CONVERSATION_ATTRIBUTES = "CLEAR_CONVERSATION_ATTRIBUTES";
export const SET_CONVERSATION_ATTRIBUTES = "SET_CONVERSATION_ATTRIBUTES";
export const SET_WIDGET_APP_CONFIG = "SET_WIDGET_APP_CONFIG";
export const SET_WIDGET_COLOR = "SET_WIDGET_COLOR";
export const UPDATE_CONVERSATION_ATTRIBUTES = "UPDATE_CONVERSATION_ATTRIBUTES";
export const TOGGLE_WIDGET_OPEN = "TOGGLE_WIDGET_OPEN";
export const SET_REFERRER_HOST = "SET_REFERRER_HOST";
export const SET_BUBBLE_VISIBILITY = "SET_BUBBLE_VISIBILITY";
export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN";
export const SET_DARK_MODE = "SET_DARK_MODE";
